import * as React from 'react';
import { connect } from 'react-redux';
import './VehicleRegLookup.css';
import KPInputTextArea from '../../../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import { handleNextStep, setQuoteData, CarRegistrationCheck } from '../../../../actions/salesActions';

class VehicleRegLookup extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            regNo: this.props.sales.regNr,
            regNoValid: (this.props.sales.regNr && this.props.sales.regNr.toString().trim().length > 0),
            submitted: false,
            nextDisabled: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleSkipLookup = this.handleSkipLookup.bind(this);
        this.handleRegLookup = this.handleRegLookup.bind(this);
    }

    async componentDidMount() {
        this.checkSubmit();
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        this.checkSubmit();
    }

    async checkSubmit() {
        let valid = (this.state.regNo && this.state.regNo.toString().trim().length > 0);
        await this.setState({ nextDisabled: !valid });
    }

    async handleSkipLookup() {
        let payload = {
            vehicleFullDescription: "",
            vehicleYear: "",
            vehicleMakeId: "",
            vehicleModelId: "",
            vehicleSeriesId: "",
            mmCode: "",
            regNr: ""
        };
        await this.props.dispatchAction(setQuoteData(payload));
        await this.props.dispatchAction(handleNextStep());
    }

    async handleRegLookup() {
        this.setState({ submitted: true, regNoValid: true });

        await this.props.dispatchAction(CarRegistrationCheck(
            this.state.regNo,
            () => {
                this.props.dispatchAction(handleNextStep());
            },
            () => {
                this.setState({ regNoValid: false });
            })
        );
    }

    public render() {
        let regNmrErrorMsg = "";
        if (!this.state.regNoValid) {
            regNmrErrorMsg = (this.state.regNo.toString().trim() === "") ? "Whoops, we require your regstration number" : "Invalid registration number. If you’re struggling, tap ‘Don’t know it’";
        }

        return (
            <div className="container">
                <p className="text-center">
                    Excellent, now we need your car’s details. The easiest way to get this, is by using your car’s registration number.
                </p>

                <div className="form-row mt-4">
                    <div className="col-12">
                        <KPInputTextArea
                            id="CarRegistration"
                            name="regNo"
                            type="input"
                            className="mb-15px"
                            label={"Reg no."}
                            alwaysShowLabel={false}
                            value={this.state.regNo}
                            notice={(this.state.submitted && !this.state.regNoValid)}
                            noticeType={"error"}
                            noticeMessage={regNmrErrorMsg}
                            successTick={false}
                            required={true}
                            readOnly={false}
                            autoFocus={false}
                            minLength={3}
                            maxLength={false}
                            disabled={false}
                            form="mainform"
                            handleChange={(e) => this.handleChange(e)}
                        />
                    </div>
                </div>

                <div className="row mt-lg-4">
                    <div className="col-md-6 text-right">
                        <button type="button" className="btn btn-outline-red btnNavigate mt-4 mt-lg-0" onClick={this.handleSkipLookup}>Don’t know it</button>
                    </div>

                    <div className="col-md-6 text-left">
                        <button type="button" className="btn btn-solid-red btnNavigate mt-4 mt-lg-0" onClick={this.handleRegLookup} disabled={this.state.nextDisabled}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleRegLookup);